const _fieldValidate = (fieldValidate, data, valuesValidate) => {
    try {
        const field = `data${fieldValidate}`;
        const value = eval(field);
        return valuesValidate.includes(value);
    } catch (error) {
        return false;
    } 
}

const _addDefault = (fieldValidate, data, addDefault) => {
    const field = `data${fieldValidate}`;
    const value = eval(field);
    return addDefault.includes(value);
}

const pathIsObject = (path, element, data) => {
    if(path.constructor === Object || typeof path === 'object') {
        const { fieldValidate } = element;
        const getInputType = eval(`data${fieldValidate}`);
        return path[getInputType];
    }
    return path;
}

const isRequiredByNotHas = (data, path, element, i) => {
    const getPath = pathIsObject(path, element, data);
    const field = `data${getPath}`;
   
    try {
        const value = eval(field); 
        
        if(value === undefined || value === null) { //data no lo tiene
           
            if(element._default.constructor === Object || typeof element._default === 'object') {
                const { fieldValidate } = element;
                const getInputType = eval(`data${fieldValidate}`);

                if(!expresionEval(element._default[getInputType], data, element, i)) {
                    if(element._default[getInputType]) return element._default[getInputType];
                    return '';
                }else {
                    return expresionEval(element._default[getInputType], data, element, i);
                }
            }
            return element._default;
        }else { //data tiene el valor
            return value;
        }
    } catch (error) {
        
        if(element._default.constructor === Object) {
            const { fieldValidate } = element;
            const getInputType = eval(`data${fieldValidate}`);           
            if(!expresionEval(element._default[getInputType], data, element, i)) {
                if(element._default[getInputType]) return element._default[getInputType];
                return '';
            }else {
                return expresionEval(element._default[getInputType], data, element, i);
            }
            
        }
        return element._default;
    }    
}


const  expresionEval = (expresion, data, element, i) => {    
    try {
        const _eval = eval(expresion);  
        if(typeof _eval === 'string' || typeof _eval === 'number' || typeof _eval === 'boolean') return _eval;
        return expresion;
    } catch (error) {
        return false;
    }
}

const  hasProperties = (element) => {
    return element.hasOwnProperty('_properties');
}

const  isValiate = (element) => {
    const validate1 = element.hasOwnProperty('fieldValidate');
    const validate2 = (element.hasOwnProperty('valuesValidate') || element.hasOwnProperty('addDefault'))
    return validate1 && validate2;
}
const  addValueDefault = (data, fieldValidate, element) => {
    const getInputType = eval(`data${fieldValidate}`);   
    return element._default[getInputType];
}

const _optional = (element) => {
    if(element.hasOwnProperty('_optional')) return element._optional;
    return false;
}

export const main = (schema, json) => {
    let newSchema = {};
    for(let i in schema) {
        let element = schema[i];        
        const { handler } = element;

        if(isValiate(element)) {
            const { fieldValidate,  valuesValidate,  addDefault } = element;           

            if(!!valuesValidate) {
                if(_fieldValidate(fieldValidate, json, valuesValidate)) {              

                    if(hasProperties(element)) {
                        newSchema[i] = main(element['_properties'], json);
                    }else {
                        newSchema[i] = isRequiredByNotHas(json, element.path, element, i);
                        if(typeof handler === 'function') newSchema[i] = handler(newSchema[i]);
                    }
                }
            }else if(!!addDefault) {
                if(_addDefault(fieldValidate, json, addDefault)) {
                    if(hasProperties(element)) {
                        newSchema[i] = main(element['_properties'], json);
                    }else {
                        newSchema[i] = addValueDefault(json, fieldValidate, element);
                    }
                }else {
                    newSchema[i] = isRequiredByNotHas(json, element.path, element, i);
                    if(typeof handler === 'function') newSchema[i] = handler(newSchema[i]);
                }
            }     

        }else {
            if(hasProperties(element)) {
                newSchema[i] = main(element['_properties'], json);
            }else {
                if(_optional(element)) {
                    if(json.hasOwnProperty(i)) newSchema[i] = json[i];
                }else {
                    newSchema[i] = isRequiredByNotHas(json, element.path, element, i);
                    if(typeof handler === 'function') newSchema[i] = handler(newSchema[i]);
                }
                
            }
        }
    }

    return newSchema;
}